import React, { Component } from 'react';


// 在任何工程計劃中只有小部份零件誤期，將影響工程之進度，敝公司，百事利器材有限公司擁有多元化及大量的氣體燃料設備配件，並把有關資料輯錄於本書之中，如閣下有某類產品不能在這書找到，請與本公司人員聯絡，敝公司員工定以多年經驗及多完化的網絡為閣下找到合適的產品，務使閣下能更有效及更短時間內完成工程。

export default class About extends React.Component {

    render() {
        const brStyle = {
            minHeight: '800px',
            padding: '400 0 500 0'
        };

        const translationTextTitleAbout = { en: "About", chi: "關於" }
        const translationTextTitleUs = { en: "Us", chi: "我們" }
        const translationTexth3 = { en: "GAS EQUIPMENT, WATER AND AIRCONDITIONING EQUIPMENT", chi: "燃氣設備，水和空調設備" }
        const translationTextp1 = { en: "In any engineering project even the smallest component can delay completion if it is late.", chi: "在任何工程計劃中只有小部份零件誤期，將影響工程之進度，" }
        const translationTextp2 = { en: "We at Preseli pride ourselves on having the largest range and stock of gas fuel handling equipment in Hong Kong. We have included the more common items in this catalogue, but if you do not find everything you need here please call us.", chi: "百事利器材有限公司擁有多元化及大量的氣體燃料設備配件，並把有關資料輯錄於本書之中，" }
        const translationTextp3 = { en: "With our extensive experience and worldwide sourcing ability we are confident of being able to help. Our job is to serve you, the engineering companies, in being able to complete your work quickly and efficiently.", chi: "如閣下有某類產品不能在這書找到，請與本公司人員聯絡，敝公司員工定以多年經驗及多完化的網絡為閣下找到合適的產品，務使閣下能更有效及更短時間內完成工程。" }


        return (
            <div style={brStyle} className="py-4 container">
                <h2 className="title-divider"><span>{translationTextTitleAbout[this.props.language]} <span className="font-weight-normal text-muted">{translationTextTitleUs[this.props.language]}</span></span><small></small></h2>
                <hr></hr>
                <h3>{translationTexth3[this.props.language]}</h3>
                <h3></h3>
                <p>{translationTextp1[this.props.language]}</p>
                <p>{translationTextp2[this.props.language]}</p>
                <p>{translationTextp3[this.props.language]}</p>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/About.js